export const options = [
  {
    label: 'Abdomen and pelvis ultrasound',
    value: 'Abdomen and pelvis ultrasound'
  },
  {label: 'Neck/thyroid ultrasound', value: 'Neck/thyroid ultrasound'},
  {label: 'Doppler', value: 'Doppler'},
  {label: 'Male fertility', value: 'Male fertility'},
  {
    label: 'Musculoskeletal ultrasound',
    value: 'Musculoskeletal ultrasound'
  },
  {label: 'Fetal Ultrasound', value: 'Fetal Ultrasound'},
  {label: 'Pediatric ultrasound', value: 'Pediatric ultrasound'},
  {label: 'Ocular ultrasound', value: 'Ocular ultrasound'}
];

export const subTopics = {
  'Pediatric ultrasound': [
    {label: 'Abdomen/KUB', value: 'Abdomen_KUB'},
    {label: 'Scrotum', value: 'Scrotum'},
    {
      label: 'Cranial Ultrasound (Neonate)',
      value: 'Cranial'
    },
    {label: 'Ultrasound Hips (DDH)', value: 'UltrasoundHips_DDH'},
    {label: 'Neonatal Spine', value: 'NeonatalSpine'},
    {label: 'Neck/Thyroid', value: 'Neck_Thyroid'}
  ],
  'Abdomen and pelvis ultrasound': [
    {label: 'Abdomen', value: 'UpperAbdomen'},
    {label: 'Pelvis', value: 'Pelvis'},
    {label: 'Pelvis (TVS)', value: 'PelvisTVS'},
    {label: 'KUB', value: 'KUB'}
  ],
  'Neck/thyroid ultrasound': [
    {label: 'Neck/Thyroid', value: 'Neck_Thyroid'},
    {label: 'Parotid/Salivary Glands', value: 'ParotidSalivaryGlands'},
    {label: 'Parathyroid', value: 'Parathyroid'},
    {label: 'Face (Local Part)', value: 'FaceLocalPart'}
  ],

  'Ocular ultrasound': [{label: 'Ocular B Scan', value: 'OcularBScan'}],
  'Fetal Ultrasound': [
    {label: 'Viability Scan', value: 'ViabilityScan'},
    {label: 'Viability Scan(Twins)', value: 'ViabilityScan_twins'},
    {
      label: 'Early Pregnancy/Dating Scan',
      value: 'EarlyPregnancyDatingScan'
    },
    {label: 'FT Scan/NT Scan', value: 'FTScanNTScan'},
    {label: 'FT Scan/NT Scan (Twins)', value: 'FTScanNTScanTwins'},
    {label: 'Early Target Scan', value: 'EarlyTargetScan'},
    {
      label: 'Early Target Scan (Twins)',
      value: 'EarlyTargetScanTwins'
    },
    {
      label: 'Target/TIFFA/Anomaly Scan',
      value: 'TargetTIFFAAnomalyScan'
    },
    {
      label: 'TargetTIFFAAnomalyScanTwins',
      value: 'TargetTIFFAAnomalyScanTwins'
    },
    {label: 'Growth Scan', value: 'GrowthScan'},
    {label: 'Growth with Doppler', value: 'GrowthwithDoppler'},
    {label: 'Growth Scan (Twins)', value: 'GrowthScanTwins'},
    {
      label: 'Growth with Doppler (Twins)',
      value: 'GrowthwithDopplerTwins'
    },
    {label: 'Fetal ECHO', value: 'FetalECHO'},
    {label: 'Fetal ECHO (Twins)', value: 'FetalECHOTwins'},
    {label: 'Fetal Neuro Sonogram', value: 'FetalNeuroSonogram'},
    {
      label: 'Fetal Neuro Sonogram (Twins)',
      value: 'FetalNeuroSonogramTwins'
    },
    {label: 'Biophysical Profile', value: 'BiophysicalProfile'},
    {label: 'AFI', value: 'AFI'}
  ],
  'Male fertility': [
    {label: 'Scrotal Doppler', value: 'ScrotalDoppler'},
    {label: 'TRUS', value: 'TRUS'},
    {
      label: 'Penile Doppler With Injection',
      value: 'PenileDopplerWithInjection'
    },
    {
      label: 'Penile Doppler Without Injection',
      value: 'PenileDopplerWithoutInjection'
    }
  ],

  'Musculoskeletal ultrasound': [
    {label: 'Shoulder (U/L)', value: 'ShoulderU_L'},
    {label: 'Knee (U/L)', value: 'KneeU_L'},
    {label: 'Ankle (U/L)', value: 'Ankle'},
    {label: 'Local Part / Limbs', value: 'LocalPartLimbs'},
    {label: 'Wrist (U/L)', value: 'Wrist'},
    {label: 'Soft Tissues (Local)', value: 'SoftTissuesLocal'}
  ],
  Doppler: [
    {
      label: 'Upper Limb Arterial/Venous Doppler (U/L)',
      value: 'UpperLimbArterialVenousDopplerU_L'
    },
    {
      label: 'Upper Limb Arterial/Venous Doppler (B/L)',
      value: 'UpperLimbArterialVenousDopplerB_L'
    },
    {
      label: 'Lower Limb Arterial/Venous Doppler (U/L)',
      value: 'LowerLimbArterialVenousDopplerU_L'
    },
    {
      label: 'Lower Limb Arterial/Venous Doppler (B/L)',
      value: 'LowerLimbArterialVenousDopplerB_L'
    },
    {label: 'Renal Doppler', value: 'RenalDoppler'},
    {label: 'Carotid Doppler', value: 'CarotidDoppler'},
    {label: 'Abdominal Doppler', value: 'AbdominalDoppler'},
    {
      label: 'Pelvic Doppler (Iliac Vessels)',
      value: 'PelvicDopplerIliacVessels'
    },
    {
      label: 'SuperficialTemporalArtery',
      value: 'SuperficialTemporalArtery'
    },
    {label: 'Portal Venous Doppler', value: 'PortalVenousDoppler'}
  ]
};

export const priceValue = {
  ViabilityScan: 1200,
  ViabilityScan_twins: 2400,

  Abdomen_KUB: 800,
  Scrotum: 1200,
  Cranial: 1200,
  UltrasoundHips_DDH: 1500,
  NeonatalSpine: 1500,
  Neck_Thyroid: 1200,
  KUB: 800,
  UpperAbdomen: 800,
  Pelvis: 600,
  PelvisTVS: 800,
  ParotidSalivaryGlands: 1000,
  Parathyroid: 1000,
  FaceLocalPart: 1000,
  OcularBScan: 800,
  EarlyPregnancyDatingScan: 800,
  FTScanNTScan: 2500,
  FTScanNTScanTwins: 4000,
  EarlyTargetScan: 2500,
  EarlyTargetScanTwins: 4000,
  TargetTIFFAAnomalyScan: 4000,
  TargetTIFFAAnomalyScanTwins: 4000,
  GrowthScan: 900,
  GrowthwithDoppler: 1400,
  GrowthScanTwins: 1800,
  GrowthwithDopplerTwins: 2800,
  FetalECHO: 1000,
  FetalECHOTwins: 2000,
  FetalNeuroSonogram: 1000,
  BiophysicalProfile: 2000,
  FetalNeuroSonogramTwins: 1000,
  FetalFSScan: 500,
  AFI: 200,
  ScrotalDoppler: 250,
  TRUS: 2500,
  PenileDopplerWithInjection: 3000,
  PenileDopplerWithoutInjection: 1000,
  ShoulderU_L: 1000,
  KneeU_L: 1000,
  Ankle: 1000,
  LocalPartLimbs: 1000,
  Wrist: 1000,
  SoftTissuesLocal: 1200,
  UpperLimbArterialVenousDopplerU_L: 2500,
  UpperLimbArterialVenousDopplerB_L: 5000,
  LowerLimbArterialVenousDopplerU_L: 2500,
  LowerLimbArterialVenousDopplerB_L: 5000,
  RenalDoppler: 2000,
  CarotidDoppler: 1500,
  AbdominalDoppler: 2500,
  PelvicDopplerIliacVessels: 2000,
  SuperficialTemporalArtery: 1500,
  PortalVenousDoppler: 2500,
  New: 500,
  FollowUp: 400,
  Consultation: 500,
  ConsultationFollicularScreening: 1000
};

export const procedures = [
  {label: 'Trial cannulation', value: 'Trial cannulation'},
  {label: 'IUI', value: 'IUI'},
  {label: 'Copper T insertion', value: 'Copper T insertion'},
  {label: 'Pessary insertion', value: 'Pessary insertion'},
  {label: 'HPV testing', value: 'HPV testing'},
  {label: 'Pap smear', value: 'Pap smear'},
  {label: 'Semen analysis', value: 'Semen analysis'},
  {label: 'Semen freezing', value: 'Semen freezing'},
  {label: 'DFI', value: 'DFI'},
  {label: 'SCSA COIMBATORE', value: 'SCSACOIMBATORE'},
  {label: 'SSG', value: 'SSG'},
  {label: 'DRESSING', value: 'DRESSING'},
  {label: 'SUTURE REMOVAL', value: 'SUTUREREMOVAL'},
  {label: 'COPPER T REMOVAL', value: 'COPPERTREMOVAL'},
  {label: 'DIFFICULT 	(STYLET)', value: 'DIFFICULTSTYLET'},
  {label: 'INJECTION CHARGES', value: 'INJECTIONCHARGES'},
  {label: 'MICRO FLUIDICS IUI', value: 'MICROFLUIDICSIUI'},
  {label: 'CTG', value: 'CTG'},
  {label: 'Karyotyping', value: 'Karyotyping'},
  {label: 'Individual Karyotyping', value: 'Individual Karyotyping'},
  {label: 'Couple Karyotyping', value: 'Couple Karyotyping'},
  {label: 'Y Chromosome Microdeletion', value: 'Y Chromosome Microdeletion'},
  {label: 'Echo', value: 'Echo'},
  {label: 'OT charges', value: 'OT charges'}
];
export const Consultation = [
  {label: 'Consultation', value: 'Consultation'},
  {label: 'Report', value: 'ConsultationReport'},
  {
    label: 'Consultation + Follicular Screening',
    value: 'ConsultationFollicularScreening'
  },
  {label: 'Dr. Ashok', value: 'Dr. Ashok'},
  {label: 'Dr. Vijayalakshmi', value: 'Dr. Vijayalakshmi'},
  {label: 'Birthing Class', value: 'Birthing Class'},
  {label: 'Breast Feeding', value: 'Breast Feeding'},
  {label: 'Genetic Counselling', value: 'Genetic Counselling'},
  {label: 'Follicular study', value: 'consultationFollicularStudy'}
];

export const price = {
  // Consultation
  Consultation: 500,
  ConsultationReport: 400,
  ConsultationFollicularScreening: 1000,
  'Dr. Ashok': 800,
  'Dr. Vijayalakshmi': 800,
  'Birthing Class': 1000,
  'Breast Feeding': 1200,
  'Genetic Counselling': 1000,
  consultationFollicularStudy: 300,

  // Procedure
  'Trial cannulation': 2000,
  IUI: 7000,
  'Copper T insertion': 2500,
  'Pessary insertion': 18000,
  'OT charges': 25000,
  'HPV testing': 2500,
  'Pap smear': 1500,
  'Semen analysis': 1000,
  'Semen freezing': 2000,
  DFI: 6000,
  SCSACOIMBATORE: 8500,
  SSG: 2000,
  DRESSING: 500,
  SUTUREREMOVAL: 500,
  COPPERTREMOVAL: 1000,
  DIFFICULTSTYLET: 1000,
  INJECTIONCHARGES: 500,
  MICROFLUIDICSIUI: 9000,
  CTG: 600,
  Karyotyping: 6000,
  'Individual Karyotyping': 3000,
  'Couple Karyotyping': 6000,
  'Y Chromosome Microdeletion': 5000,
  Echo: 2000,

  // Scan

  // Fetal Ultrasound
  'Viability scan - Fetal Ultrasound': 1200,
  'Viability scan (Twins) - Fetal Ultrasound': 2400,
  'NT scan - Fetal Ultrasound': 3000,
  'NT scan (Twins) - Fetal Ultrasound': 6000,
  'Early target scan - Fetal Ultrasound': 3000,
  'Early target scan (Twins) - Fetal Ultrasound': 5000,
  'Anomaly scan - Fetal Ultrasound': 3000,
  'Anomaly scan (Twins) - Fetal Ultrasound': 6000,
  'Growth with doppler - Fetal Ultrasound': 2500,
  'Growth with Doppler (Twins) - Fetal Ultrasound': 5000,
  'FHR Screening - Fetal Ultrasound': 500,
  'Liqour - Fetal Ultrasound': 500,
  '3D Growth - Fetal Ultrasound': 4500,
  'Fetal ECHO - Fetal Ultrasound': 1500,
  'Fetal ECHO (Twins) - Fetal Ultrasound': 3000,
  'First (F.S) Scan': 500,

  // Abdomen and pelvis ultrasound
  'Whole Abdomen - Abdomen and pelvis ultrasound': 500,
  'Pelvis screening - Abdomen and pelvis ultrasound': 500,
  'Pelvis - Abdomen and pelvis ultrasound': 1200,
  'Pelvis (3D) - Abdomen and pelvis ultrasound': 2500,
  'KUB - Abdomen and pelvis ultrasound': 1500,
  'Breasts - Abdomen and pelvis ultrasound': 1500,

  // Neck / thyroid ultrasound
  'Neck / thyroid - Neck / thyroid ultrasound': 1300,
  'Parotid / salivary glands - Neck / thyroid ultrasound': 1000,
  'Face (local part) - Neck / thyroid ultrasound': 1000,

  // Doppler
  'Upper limb arterial / venous doppler (U/L) - Doppler': 2500,
  'Upper limb arterial / venous doppler (B/L) - Doppler': 5000,
  'Lower limb arterial / venous doppler (U/L) - Doppler': 2500,
  'Lower limb arterial / venous doppler (B/L) - Doppler': 5000,
  'Renal doppler - Doppler': 2000,
  'Carotid doppler - Doppler': 2000,
  'Abdominal doppler - Doppler': 2500,
  'Pelvic doppler (Iliac vessels) - Doppler': 2000,
  'Portal venous doppler - Doppler': 2500,

  // Musculoskeletal ultrasound
  'Shoulder (U/L) - Musculoskeletal ultrasound': 1000,
  'Knee (U/L) - Musculoskeletal ultrasound': 1000,
  'Ankle (U/L) - Musculoskeletal ultrasound': 1000,
  'Wrist (U/L) - Musculoskeletal ultrasound': 1000,
  'Soft tissues (local) - Musculoskeletal ultrasound': 1000,

  // Male fertility
  'Scrotal doppler - Male fertility': 3500,
  'TRUS - Male fertility': 3000,
  'Penile doppler (with injection) - Male fertility': 3000,
  'Penile doppler without injection - Male fertility': 1000,

  // Pediatric ultrasound
  'Abdomen / KUB - Pediatric ultrasound': 800,
  'Scrotum - Pediatric ultrasound': 1200,
  'Cranial ultrasound (Neonate) - Pediatric ultrasound': 1200,
  'Ultrasound hips - Pediatric ultrasound': 1500,
  'Neonatal spine - Pediatric ultrasound': 1500,
  'Neck / thyroid - Pediatric ultrasound': 1200,

  // Injection
  'Follisurge - 50_Injection': 1540,
  'Follisurge - 75_Injection': 2310,
  'Follisurge - 150_Injection': 4620,
  'Follisurge - 225_Injection': 6930,
  'Follisurge - 300_Injection': 9240,

  'Pergoveris - 75_Injection': 2098,
  'Pergoveris - 150_Injection': 5817,
  'Pergoveris - 225_Injection': 8725,
  'Pergoveris - 300_Injection': 11634,
  'Pergoveris - 375_Injection': 14542,
  'Pergoveris - 450_Injection': 17451,

  'Gonal F - 50_Injection': 1404,
  'Gonal F - 75_Injection': 2106,
  'Gonal F - 150_Injection': 4211,
  'Gonal F - 225_Injection': 6316,
  'Gonal F - 300_Injection': 8421,

  'Ovutas HP - 75_Injection': 1117,
  'Ovutas HP - 150_Injection': 2233,

  'Menotas XP - 50_Injection': 890,
  'Menotas XP - 75_Injection': 1334,
  'Menotas XP - 150_Injection': 2668,
  'Menotas XP - 225_Injection': 4002,
  'Menotas XP - 300_Injection': 5335,
  'Menotas XP - 375_Injection': 6669,
  'Menotas XP - 450_Injection': 8003,
  'Menotas XP - 1200_Injection': 21340,

  'Decapeptyl - 0.1_Injection': 363,
  'Decapeptyl - 0.2_Injection': 726,
  'Decapeptyl - 0.3_Injection': 1088,

  'Ovitrelle - 250 mcg_Injection': 2001,

  'Ovocito - 5000_Injection': 439,
  'Ovocito - 10000_Injection': 878,

  'Puretrig - 5000_Injection': 438,
  'Puretrig - 10000_Injection': 876,

  'Graffipure - 50_Injection': 609,
  'Graffipure - 75_Injection': 914,
  'Graffipure - 150_Injection': 1830,
  'Graffipure - 225_Injection': 2744,
  'Graffipure - 300_Injection': 3659,
  'Graffipure - 375_Injection': 4574,
  'Graffipure - 450_Injection': 5474,
  'Graffipure - 600_Injection': 7317,
  'Follicular study': 300
};
export const scan = [
  // Fetal Ultrasound
  {
    label: 'Viability scan - Fetal Ultrasound',
    value: 'Viability scan - Fetal Ultrasound'
  },
  {
    label: 'Viability scan (Twins) - Fetal Ultrasound',
    value: 'Viability scan (Twins) - Fetal Ultrasound'
  },
  {
    label: 'NT scan - Fetal Ultrasound',
    value: 'NT scan - Fetal Ultrasound'
  },
  {
    label: 'NT scan (Twins) - Fetal Ultrasound',
    value: 'NT scan (Twins) - Fetal Ultrasound'
  },
  {
    label: 'Early target scan - Fetal Ultrasound',
    value: 'Early target scan - Fetal Ultrasound'
  },
  {
    label: 'Early target scan (Twins) - Fetal Ultrasound',
    value: 'Early target scan (Twins) - Fetal Ultrasound'
  },
  {
    label: 'Anomaly scan - Fetal Ultrasound',
    value: 'Anomaly scan - Fetal Ultrasound'
  },
  {
    label: 'Anomaly scan (Twins) - Fetal Ultrasound',
    value: 'Anomaly scan (Twins) - Fetal Ultrasound'
  },
  {
    label: 'Growth with doppler - Fetal Ultrasound',
    value: 'Growth with doppler - Fetal Ultrasound'
  },
  {
    label: 'Growth with Doppler (Twins) - Fetal Ultrasound',
    value: 'Growth with Doppler (Twins) - Fetal Ultrasound'
  },
  {
    label: 'FHR Screening - Fetal Ultrasound',
    value: 'FHR Screening - Fetal Ultrasound'
  },
  {
    label: 'Liqour - Fetal Ultrasound',
    value: 'Liqour - Fetal Ultrasound'
  },
  {
    label: '3D Growth - Fetal Ultrasound',
    value: '3D Growth - Fetal Ultrasound'
  },
  {
    label: 'Fetal ECHO - Fetal Ultrasound',
    value: 'Fetal ECHO - Fetal Ultrasound'
  },
  {
    label: 'Fetal ECHO (Twins) - Fetal Ultrasound',
    value: 'Fetal ECHO (Twins) - Fetal Ultrasound'
  },
  {
    label: 'First (F.S) Scan',
    value: 'First (F.S) Scan'
  },
  // Abdomen and pelvis ultrasound
  {
    label: 'Whole Abdomen - Abdomen and pelvis ultrasound',
    value: 'Whole Abdomen - Abdomen and pelvis ultrasound'
  },
  {
    label: 'Pelvis screening - Abdomen and pelvis ultrasound',
    value: 'Pelvis screening - Abdomen and pelvis ultrasound'
  },
  {
    label: 'Pelvis - Abdomen and pelvis ultrasound',
    value: 'Pelvis - Abdomen and pelvis ultrasound'
  },
  {
    label: 'Pelvis (3D) - Abdomen and pelvis ultrasound',
    value: 'Pelvis (3D) - Abdomen and pelvis ultrasound'
  },
  {
    label: 'KUB - Abdomen and pelvis ultrasound',
    value: 'KUB - Abdomen and pelvis ultrasound'
  },
  {
    label: 'Breasts - Abdomen and pelvis ultrasound',
    value: 'Breasts - Abdomen and pelvis ultrasound'
  },
  // Neck / thyroid ultrasound
  {
    label: 'Neck / thyroid - Neck / thyroid ultrasound',
    value: 'Neck / thyroid - Neck / thyroid ultrasound'
  },
  {
    label: 'Parotid / salivary glands - Neck / thyroid ultrasound',
    value: 'Parotid / salivary glands - Neck / thyroid ultrasound'
  },
  {
    label: 'Face (local part) - Neck / thyroid ultrasound',
    value: 'Face (local part) - Neck / thyroid ultrasound'
  },
  // Doppler
  {
    label: 'Upper limb arterial / venous doppler (U/L) - Doppler',
    value: 'Upper limb arterial / venous doppler (U/L) - Doppler'
  },
  {
    label: 'Upper limb arterial / venous doppler (B/L) - Doppler',
    value: 'Upper limb arterial / venous doppler (B/L) - Doppler'
  },
  {
    label: 'Lower limb arterial / venous doppler (U/L) - Doppler',
    value: 'Lower limb arterial / venous doppler (U/L) - Doppler'
  },
  {
    label: 'Lower limb arterial / venous doppler (B/L) - Doppler',
    value: 'Lower limb arterial / venous doppler (B/L) - Doppler'
  },
  {
    label: 'Renal doppler - Doppler',
    value: 'Renal doppler - Doppler'
  },
  {
    label: 'Carotid doppler - Doppler',
    value: 'Carotid doppler - Doppler'
  },
  {
    label: 'Abdominal doppler - Doppler',
    value: 'Abdominal doppler - Doppler'
  },
  {
    label: 'Pelvic doppler (Iliac vessels) - Doppler',
    value: 'Pelvic doppler (Iliac vessels) - Doppler'
  },
  {
    label: 'Portal venous doppler - Doppler',
    value: 'Portal venous doppler - Doppler'
  },
  // Musculoskeletal ultrasound
  {
    label: 'Shoulder (U/L) - Musculoskeletal ultrasound',
    value: 'Shoulder (U/L) - Musculoskeletal ultrasound'
  },
  {
    label: 'Knee (U/L) - Musculoskeletal ultrasound',
    value: 'Knee (U/L) - Musculoskeletal ultrasound'
  },
  {
    label: 'Ankle (U/L) - Musculoskeletal ultrasound',
    value: 'Ankle (U/L) - Musculoskeletal ultrasound'
  },
  {
    label: 'Wrist (U/L) - Musculoskeletal ultrasound',
    value: 'Wrist (U/L) - Musculoskeletal ultrasound'
  },
  {
    label: 'Soft tissues (local) - Musculoskeletal ultrasound',
    value: 'Soft tissues (local) - Musculoskeletal ultrasound'
  },
  // Male fertility
  {
    label: 'Scrotal doppler - Male fertility',
    value: 'Scrotal doppler - Male fertility'
  },
  {
    label: 'TRUS - Male fertility',
    value: 'TRUS - Male fertility'
  },
  {
    label: 'Penile doppler (with injection) - Male fertility',
    value: 'Penile doppler (with injection) - Male fertility'
  },
  {
    label: 'Penile doppler without injection - Male fertility',
    value: 'Penile doppler without injection - Male fertility'
  },
  // Pediatric ultrasound
  {
    label: 'Abdomen / KUB - Pediatric ultrasound',
    value: 'Abdomen / KUB - Pediatric ultrasound'
  },
  {
    label: 'Scrotum - Pediatric ultrasound',
    value: 'Scrotum - Pediatric ultrasound'
  },
  {
    label: 'Cranial ultrasound (Neonate) - Pediatric ultrasound',
    value: 'Cranial ultrasound (Neonate) - Pediatric ultrasound'
  },
  {
    label: 'Ultrasound hips - Pediatric ultrasound',
    value: 'Ultrasound hips - Pediatric ultrasound'
  },
  {
    label: 'Neonatal spine - Pediatric ultrasound',
    value: 'Neonatal spine - Pediatric ultrasound'
  },
  {
    label: 'Neck / thyroid - Pediatric ultrasound',
    value: 'Neck / thyroid - Pediatric ultrasound'
  },
  {
    label: 'Follicular study',
    value: 'Follicular study'
  }
];

export const injections = [
  // Follisurge 300 pen
  {label: 'Follisurge - 50', value: 'Follisurge - 50_Injection'},
  {label: 'Follisurge - 75', value: 'Follisurge - 75_Injection'},
  {label: 'Follisurge - 150', value: 'Follisurge - 150_Injection'},
  {label: 'Follisurge - 225', value: 'Follisurge - 225_Injection'},
  {label: 'Follisurge - 300', value: 'Follisurge - 300_Injection'},

  // Pergoveris 450 pen
  {label: 'Pergoveris - 75', value: 'Pergoveris - 75_Injection'},
  {label: 'Pergoveris - 150', value: 'Pergoveris - 150_Injection'},
  {label: 'Pergoveris - 225', value: 'Pergoveris - 225_Injection'},
  {label: 'Pergoveris - 300', value: 'Pergoveris - 300_Injection'},
  {label: 'Pergoveris - 375', value: 'Pergoveris - 375_Injection'},
  {label: 'Pergoveris - 450', value: 'Pergoveris - 450_Injection'},

  // Gonal F 300 pen
  {label: 'Gonal F - 50', value: 'Gonal F - 50_Injection'},
  {label: 'Gonal F - 75', value: 'Gonal F - 75_Injection'},
  {label: 'Gonal F - 150', value: 'Gonal F - 150_Injection'},
  {label: 'Gonal F - 225', value: 'Gonal F - 225_Injection'},
  {label: 'Gonal F - 300', value: 'Gonal F - 300_Injection'},

  // Ovutas HP
  {label: 'Ovutas HP - 75', value: 'Ovutas HP - 75_Injection'},
  {label: 'Ovutas HP - 150', value: 'Ovutas HP - 150_Injection'},

  // Menotas XP 1200 vial
  {label: 'Menotas XP - 50', value: 'Menotas XP - 50_Injection'},
  {label: 'Menotas XP - 75', value: 'Menotas XP - 75_Injection'},
  {label: 'Menotas XP - 150', value: 'Menotas XP - 150_Injection'},
  {label: 'Menotas XP - 225', value: 'Menotas XP - 225_Injection'},
  {label: 'Menotas XP - 300', value: 'Menotas XP - 300_Injection'},
  {label: 'Menotas XP - 375', value: 'Menotas XP - 375_Injection'},
  {label: 'Menotas XP - 450', value: 'Menotas XP - 450_Injection'},
  {label: 'Menotas XP - 1200', value: 'Menotas XP - 1200_Injection'},

  // Decapeptyl
  {label: 'Decapeptyl - 0.1', value: 'Decapeptyl - 0.1_Injection'},
  {label: 'Decapeptyl - 0.2', value: 'Decapeptyl - 0.2_Injection'},
  {label: 'Decapeptyl - 0.3', value: 'Decapeptyl - 0.3_Injection'},

  // Ovitrelle 250 mcg
  {label: 'Ovitrelle - 250 mcg', value: 'Ovitrelle - 250 mcg_Injection'},

  // Ovocito 5000
  {label: 'Ovocito - 5000', value: 'Ovocito - 5000_Injection'},
  {label: 'Ovocito - 10000', value: 'Ovocito - 10000_Injection'},

  // Puretrig 5000
  {label: 'Puretrig - 5000', value: 'Puretrig - 5000_Injection'},
  {label: 'Puretrig - 10000', value: 'Puretrig - 10000_Injection'},

  // Graffipure 600 vial
  {label: 'Graffipure - 50', value: 'Graffipure - 50_Injection'},
  {label: 'Graffipure - 75', value: 'Graffipure - 75_Injection'},
  {label: 'Graffipure - 150', value: 'Graffipure - 150_Injection'},
  {label: 'Graffipure - 225', value: 'Graffipure - 225_Injection'},
  {label: 'Graffipure - 300', value: 'Graffipure - 300_Injection'},
  {label: 'Graffipure - 375', value: 'Graffipure - 375_Injection'},
  {label: 'Graffipure - 450', value: 'Graffipure - 450_Injection'},
  {label: 'Graffipure - 600', value: 'Graffipure - 600_Injection'}
];
